import classNames from 'classnames';
import React from 'react';

import {usePersonalPlanLandingBannerNotice} from '@udemy/notices';
import {HeroBannerSkeleton} from '@udemy/shared-one-udemy-components';
import {useConsumerSubscriptionPlan} from '@udemy/subscription-graphql';

import {withAboveTheFoldProvider} from 'src/components/above-the-fold/with-above-the-fold-provider.react-component';

import {PersonalPlanLandingPageProps} from '../../personal-plan-landing-page-body.react-component';
import styles from './personal-plan-banner.module.less';
import {PersonalPlanBanner} from './personal-plan-banner.react-component';

const WithAboveTheFoldPersonalPlanBanner = withAboveTheFoldProvider(PersonalPlanBanner);

export const PersonalPlanBannerWrapper = ({isPPLPRevamp}: PersonalPlanLandingPageProps) => {
    const notice = usePersonalPlanLandingBannerNotice();
    const plan = useConsumerSubscriptionPlan();
    // If either notice or plan are still loading, display loading state for hero banner
    if (notice.isLoading || plan?.isLoading) {
        return (
            <div className={classNames('ud-container', styles['marketing-hero-banner'])}>
                <HeroBannerSkeleton />
            </div>
        );
    }
    // Display fallback banner if no notices are available
    const noticeUnavailable = notice && !notice.isLoading && !notice.notices.length;
    const subscriptionPlanUnavailable = !plan;
    if (noticeUnavailable || subscriptionPlanUnavailable) {
        return <WithAboveTheFoldPersonalPlanBanner plan={plan} isPPLPRevamp={isPPLPRevamp} />;
    }
    return (
        <WithAboveTheFoldPersonalPlanBanner
            plan={plan}
            notice={notice.notices[0]}
            isPPLPRevamp={isPPLPRevamp}
        />
    );
};
